import styled from "styled-components";

const ChartWrapper = styled('div')`
  position: relative;
  height: 600px;
  
`;

export default ChartWrapper;
